// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!./global.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NOTE: card layout is managed by the parent grid and included in it's shadow DOM */

.card-container {
  display: flex;
  /* we need these 100% to ensure the slickgrid has dimensions */
  flex-direction: column;
  justify-content: center;
  /*align-items: flex-start;*/
  flex-grow: 0;
  /*box-shadow: 0px 2px 8px 0px rgba(0, 93, 152, 0.15);*/
  border-radius: var(--Radius-radius-l, 16px);
  background-color: white;

  /* attempting to move margin/padding away from gridstack and into the div */
  width: 100%;
  height: 100%;
  min-width: 208px; 
  min-height: 135px;
  position: relative;
  overflow: hidden;
}
.card-header {
  display: flex;
  flex-grow: 0;
  height: 0px;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}
.card-header.edit-mode-enabled {
  height: 20px;
  min-height: 20px;
  max-height: 20px;
  padding: 0 6px;
  background: #eef3f7;
  border-radius: var(--Radius-radius-l, 4px) var(--Radius-radius-l, 4px) 0 0;
  border-bottom: 1px solid #dde6ee;
  cursor: pointer;
  justify-content: flex-end;
  overflow: hidden;
  pointer-events: auto;
}

.card-header.edit-mode-enabled .card-title {
  display: none;
}

.card-header.edit-mode-enabled .card-actions {
  display: flex;
  height: 100%;
  align-items: center;
  padding: 0;
  gap: 6px;
  border: 0;
  border-radius: 0;
  background: transparent;
  transform: none;
}

.card-title {
  display: flex;
  padding: 4px;
  color: #444;
}
.card-actions {
  display: flex;
  align-items: center;
  padding: 4px;
}
.card-button {
  gap: var(--Spacings-Spacing-03, 12px);
  cursor: pointer;
  font-weight: 600;
  user-select: none;
  padding-left: 6px;
}
.card-body {
  display: flex;
  flex-grow: 1;
}

/* card buttons */
.card-button.edit-mode {
  display: none;
}
.card-button.edit-mode-enabled.hide {
  display: none;
}
.card-button.edit-mode-enabled {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0 2px;
}
.close-button {
  position: absolute;
  right: 13px;
  top: 5px;
  width: 16px;
  height: 16px;
  opacity: 0.3;
}
.close-button:hover {
  opacity: 1;
}
.close-button:before, .close-button:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 16px;
  width: 2px;
  background-color: #333;
}
.close-button:before {
  transform: rotate(45deg);
}
.close-button:after {
  transform: rotate(-45deg);
}

/* prev button */
.prev-button {
  position: absolute;
  overflow: hidden;
  right: 50px;
  top: 5px;
  width: 22px;
  height: 16px;
  opacity: 0.3;
  clip-path: inset(0 0 0 16px);
}
.prev-button:hover {
  opacity: 1;
}
.prev-button:before, .prev-button:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 16px;
  width: 2px;
  background-color: #333;
}
.prev-button:before {
  transform: rotate(45deg);
}
.prev-button:after {
  transform: rotate(-45deg);
}

/* next button */
.next-button {
  position: absolute;
  overflow: hidden;
  right: 25px;
  top: 5px;
  width: 22px;
  height: 16px;
  opacity: 0.3;
  clip-path: inset(0 6px 0 0);
}
.next-button:hover {
  opacity: 1;
}
.next-button:before, .next-button:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 16px;
  width: 2px;
  background-color: #333;
}
.next-button:before {
  transform: rotate(45deg);
}
.next-button:after {
  transform: rotate(-45deg);
}

.card-action-link {
  padding-left: 12px;
  color: #222;
  font-weight: 700;
  text-decoration: none;
  /*cursor: pointer;*/
}
.card-action-link:hover {
  background-color: var(--lighter-grey);
}

.card-search {
  display: flex;
  align-items: center;
  flex: 1;
  max-width: 300px;
  margin: 0 8px;
}

.card-search input {
  width: 100%;
  padding: 4px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 13px;
  background: white;
}

.card-search input::placeholder {
  color: #999;
}

.card-search.hide {
  display: none !important;
}

.hide {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/card.css"],"names":[],"mappings":"AACA,oFAAoF;;AAEpF;EACE,aAAa;EACb,8DAA8D;EAC9D,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;EACZ,sDAAsD;EACtD,2CAA2C;EAC3C,uBAAuB;;EAEvB,2EAA2E;EAC3E,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,0EAA0E;EAC1E,gCAAgC;EAChC,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf","sourcesContent":["@import url(\"./global.css\");\n/* NOTE: card layout is managed by the parent grid and included in it's shadow DOM */\n\n.card-container {\n  display: flex;\n  /* we need these 100% to ensure the slickgrid has dimensions */\n  flex-direction: column;\n  justify-content: center;\n  /*align-items: flex-start;*/\n  flex-grow: 0;\n  /*box-shadow: 0px 2px 8px 0px rgba(0, 93, 152, 0.15);*/\n  border-radius: var(--Radius-radius-l, 16px);\n  background-color: white;\n\n  /* attempting to move margin/padding away from gridstack and into the div */\n  width: 100%;\n  height: 100%;\n  min-width: 208px; \n  min-height: 135px;\n  position: relative;\n  overflow: hidden;\n}\n.card-header {\n  display: flex;\n  flex-grow: 0;\n  height: 0px;\n  box-sizing: border-box;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n}\n.card-header.edit-mode-enabled {\n  height: 20px;\n  min-height: 20px;\n  max-height: 20px;\n  padding: 0 6px;\n  background: #eef3f7;\n  border-radius: var(--Radius-radius-l, 4px) var(--Radius-radius-l, 4px) 0 0;\n  border-bottom: 1px solid #dde6ee;\n  cursor: pointer;\n  justify-content: flex-end;\n  overflow: hidden;\n  pointer-events: auto;\n}\n\n.card-header.edit-mode-enabled .card-title {\n  display: none;\n}\n\n.card-header.edit-mode-enabled .card-actions {\n  display: flex;\n  height: 100%;\n  align-items: center;\n  padding: 0;\n  gap: 6px;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  transform: none;\n}\n\n.card-title {\n  display: flex;\n  padding: 4px;\n  color: #444;\n}\n.card-actions {\n  display: flex;\n  align-items: center;\n  padding: 4px;\n}\n.card-button {\n  gap: var(--Spacings-Spacing-03, 12px);\n  cursor: pointer;\n  font-weight: 600;\n  user-select: none;\n  padding-left: 6px;\n}\n.card-body {\n  display: flex;\n  flex-grow: 1;\n}\n\n/* card buttons */\n.card-button.edit-mode {\n  display: none;\n}\n.card-button.edit-mode-enabled.hide {\n  display: none;\n}\n.card-button.edit-mode-enabled {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  padding: 0 2px;\n}\n.close-button {\n  position: absolute;\n  right: 13px;\n  top: 5px;\n  width: 16px;\n  height: 16px;\n  opacity: 0.3;\n}\n.close-button:hover {\n  opacity: 1;\n}\n.close-button:before, .close-button:after {\n  position: absolute;\n  left: 15px;\n  content: ' ';\n  height: 16px;\n  width: 2px;\n  background-color: #333;\n}\n.close-button:before {\n  transform: rotate(45deg);\n}\n.close-button:after {\n  transform: rotate(-45deg);\n}\n\n/* prev button */\n.prev-button {\n  position: absolute;\n  overflow: hidden;\n  right: 50px;\n  top: 5px;\n  width: 22px;\n  height: 16px;\n  opacity: 0.3;\n  clip-path: inset(0 0 0 16px);\n}\n.prev-button:hover {\n  opacity: 1;\n}\n.prev-button:before, .prev-button:after {\n  position: absolute;\n  left: 15px;\n  content: ' ';\n  height: 16px;\n  width: 2px;\n  background-color: #333;\n}\n.prev-button:before {\n  transform: rotate(45deg);\n}\n.prev-button:after {\n  transform: rotate(-45deg);\n}\n\n/* next button */\n.next-button {\n  position: absolute;\n  overflow: hidden;\n  right: 25px;\n  top: 5px;\n  width: 22px;\n  height: 16px;\n  opacity: 0.3;\n  clip-path: inset(0 6px 0 0);\n}\n.next-button:hover {\n  opacity: 1;\n}\n.next-button:before, .next-button:after {\n  position: absolute;\n  left: 15px;\n  content: ' ';\n  height: 16px;\n  width: 2px;\n  background-color: #333;\n}\n.next-button:before {\n  transform: rotate(45deg);\n}\n.next-button:after {\n  transform: rotate(-45deg);\n}\n\n.card-action-link {\n  padding-left: 12px;\n  color: #222;\n  font-weight: 700;\n  text-decoration: none;\n  /*cursor: pointer;*/\n}\n.card-action-link:hover {\n  background-color: var(--lighter-grey);\n}\n\n.card-search {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  max-width: 300px;\n  margin: 0 8px;\n}\n\n.card-search input {\n  width: 100%;\n  padding: 4px 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 13px;\n  background: white;\n}\n\n.card-search input::placeholder {\n  color: #999;\n}\n\n.card-search.hide {\n  display: none !important;\n}\n\n.hide {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
